export enum SemiTrailerSize {
  MEGA = 'mega',
  HALF_MEGA = 'half-mega',
  STANDARD = 'standard',
}
